export const commonEn: Record<string, string> = {
  '语言': 'Language',
  '跟随系统': 'Follow system',
  '系统': 'System',
  '浅色': 'Light',
  '深色': 'Dark',
  '当前主题: {{p0}}': 'Current theme: {{p0}}',
  '基于 Cloudflare 部署的多厂商 OSS 文件管理系统': 'Multi-provider object storage management, powered by Cloudflare',
  '文件管理系统': 'File management',
  '概览': 'Overview',
  '文件': 'Files',
  '收藏': 'Starred',
  '分享': 'Shares',
  '上传任务': 'Upload tasks',
  '离线下载': 'Remote downloads',
  '存储分析': 'Storage analytics',
  '回收站': 'Trash',
  '存储桶': 'Buckets',
  '权限管理': 'Permissions',
  '设置': 'Settings',
  '管理': 'Admin',
  '管理后台': 'Administration',
  '快捷键': 'Keyboard shortcuts',
  '退出': 'Sign out',
  '退出登录': 'Sign out',
  '更多': 'More',
  '菜单': 'Menu',
  '存储空间': 'Storage',
  '快捷操作': 'Quick actions',
  '功能': 'Features',
  '下载': 'Download',
  '上传': 'Upload',
  '上传文件': 'Upload files',
  '新建文件夹': 'New folder',
  '新建文件': 'New file',
  '打开文件夹': 'Open folder',
  '打开': 'Open',
  '取消收藏': 'Unstar',
  '分享文件夹': 'Share folder',
  '直链管理': 'Direct links',
  '创建上传链接': 'Create upload link',
  '版本历史': 'Version history',
  '标签管理': 'Manage tags',
  '文件夹设置': 'Folder settings',
  '重命名': 'Rename',
  '移动到...': 'Move to...',
  '复制': 'Copy',
  '剪切': 'Cut',
  '粘贴': 'Paste',
  '移入回收站': 'Move to trash',
  '刷新': 'Refresh',
  '全选': 'Select all',
  '粘贴 ({{p0}} 个项目)': 'Paste ({{p0}} items)',
  '创建成功': 'Created successfully',
  '创建失败': 'Creation failed',
  '文件创建成功': 'File created',
  '文件创建失败': 'File creation failed',
  '已移入回收站': 'Moved to trash',
  '删除失败': 'Deletion failed',
  '重命名成功': 'Renamed successfully',
  '重命名失败': 'Rename failed',
  '移动成功': 'Moved successfully',
  '移动失败': 'Move failed',
  '分享链接已复制': 'Share link copied',
  '创建分享失败': 'Failed to create share',
  '批量删除完成': 'Batch deletion completed',
  '批量删除失败': 'Batch deletion failed',
  '批量移动完成': 'Batch move completed',
  '批量移动失败': 'Batch move failed',
  '批量复制完成': 'Batch copy completed',
  '批量复制失败': 'Batch copy failed',
  '成功 {{p0}} 个，失败 {{p1}} 个': '{{p0}} succeeded, {{p1}} failed',
  '「{{p0}}」超出 Telegram 存储桶 500MB 上限（当前 {{p1}} MB）': '"{{p0}}" exceeds the Telegram bucket limit of 500 MB (current size: {{p1}} MB)',
  '上传成功': 'Uploaded successfully',
  '上传失败': 'Upload failed',
  '上传安全限制': 'Upload security restriction',
  '操作失败': 'Operation failed',
  '请求失败': 'Request failed',
  '请求参数错误': 'Invalid request parameters',
  '未授权，请先登录': 'Please sign in to continue',
  '权限不足': 'Insufficient permissions',
  '资源不存在': 'Resource not found',
  '资源冲突': 'Resource conflict',
  '请求过于频繁，请稍后重试': 'Too many requests. Please try again later',
  '服务器内部错误': 'Internal server error',
  '服务暂时不可用，请稍后重试': 'Service temporarily unavailable. Please try again later',
  '请求超时，请稍后重试': 'Request timed out. Please try again later',
  '网络错误，请检查网络连接': 'Network error. Please check your connection',
  '发生未知错误': 'An unknown error occurred',
  '网络错误': 'Network error',
  '请求超时': 'Request timed out',
  '登录已过期': 'Sign-in expired',
  '服务器错误': 'Server error',
  '图片': 'Images',
  '视频': 'Videos',
  '音频': 'Audio',
  '文本': 'Text',
  '取消选择/关闭': 'Clear selection / Close',
  '删除选中项': 'Delete selection',
  '打开/确认': 'Open / Confirm',
  '向上移动': 'Move up',
  '向下移动': 'Move down',
  '切换网格视图': 'Switch to grid view',
  '切换列表视图': 'Switch to list view',
  '聚焦搜索框': 'Focus search',
  '取消选择': 'Clear selection',
  '删除': 'Delete',
  '向上': 'Up',
  '向下': 'Down',
  '网格视图': 'Grid view',
  '列表视图': 'List view',
  '搜索': 'Search',
  '当前存储不支持直传或直传失败，已切换为代理完整上传，请勿关闭页面。旧任务仍不能续传，请在文件列表重新选择原文件完整上传。': 'Direct upload is unavailable. Switched to a full proxy upload; keep this page open. Old tasks cannot resume. Select the original file again in the file list to upload it in full.',
  '安全限制：旧上传任务的断点续传已暂停，请返回文件列表重新选择原文件完整上传。': 'Security restriction: resuming old uploads is disabled. Select the original file again in the file list to upload it in full.',
  '上传初始化未返回有效凭据': 'Upload initialization did not return valid credentials',
  '分片上传初始化未返回有效凭据': 'Multipart upload initialization did not return valid credentials',
  '分片上传未返回有效 URL': 'Multipart upload did not return a valid URL',
  '上传初始化未返回有效 URL': 'Upload initialization did not return a valid URL',
  '预签名直传不可用，已切换到代理上传': 'Presigned direct upload unavailable; switched to proxy upload',
  '预签名上传：服务器未返回上传 URL': 'Presigned upload: the server did not return an upload URL',
  '预签名直传失败，已切换到代理上传': 'Presigned direct upload failed; switched to proxy upload',
  '预签名分片上传不可用，已切换到代理上传': 'Presigned multipart upload unavailable; switched to proxy upload',
  '分片上传初始化：服务器返回了无效的响应': 'Multipart upload initialization: invalid server response',
  '代理分片上传失败': 'Proxy multipart upload failed',
  '直传失败 ({{p0}}): {{p1}}': 'Direct upload failed ({{p0}}): {{p1}}',
  '直传网络错误（可能是 CORS 问题）': 'Direct upload network error (possibly a CORS issue)',
  '直传请求超时': 'Direct upload timed out',
  '分片上传失败：服务器未返回 ETag': 'Multipart upload failed: the server did not return an ETag',
  '分片上传失败 ({{p0}})': 'Multipart upload failed ({{p0}})',
  '分片上传网络错误': 'Multipart upload network error',
  '分片上传超时': 'Multipart upload timed out',
  '分片 {{p0}} 上传失败': 'Failed to upload part {{p0}}',
  '服务暂时不可用': 'Service temporarily unavailable',
  '无效的请求': 'Invalid request',
  '该功能已禁用': 'This feature is disabled',
  '参数验证失败': 'Parameter validation failed',
  '缺少必要参数': 'Required parameter missing',
  '参数格式无效': 'Invalid parameter format',
  '参数超出有效范围': 'Parameter out of range',
  '登录已过期，请重新登录': 'Your sign-in has expired. Please sign in again',
  '无效的登录凭证': 'Invalid sign-in credentials',
  '缺少登录凭证': 'Sign-in credentials missing',
  '会话已过期': 'Session expired',
  '会话已被注销': 'Session revoked',
  '邮箱格式无效': 'Invalid email address',
  '密码格式无效': 'Invalid password format',
  '密码长度不足，至少需要6位': 'Password must contain at least 6 characters',
  '密码强度不足': 'Password is too weak',
  '用户名格式无效': 'Invalid username',
  '用户名过长': 'Username is too long',
  '账户已锁定，请稍后重试': 'Account locked. Please try again later',
  '登录设备数量已达上限': 'Signed-in device limit reached',
  '账户已被禁用': 'Account disabled',
  '需要管理员权限': 'Administrator access required',
  '该邮箱已被注册': 'This email is already registered',
  '该邮箱未注册': 'This email is not registered',
  '密码错误': 'Incorrect password',
  '邮箱未验证': 'Email not verified',
  '验证链接已过期': 'Verification link expired',
  '验证链接无效': 'Invalid verification link',
  '验证链接已使用': 'Verification link already used',
  '邮件发送失败': 'Failed to send email',
  '邮件服务未配置': 'Email service is not configured',
  '文件不存在': 'File not found',
  '文件大小超过限制': 'File exceeds the size limit',
  '不支持的文件类型': 'Unsupported file type',
  '文件已损坏': 'File is corrupted',
  '文件内容为空': 'File is empty',
  '文件上传失败': 'File upload failed',
  '文件下载失败': 'File download failed',
  '文件删除失败': 'File deletion failed',
  '该文件类型不支持预览': 'Preview is not supported for this file type',
  '文件内容不存在': 'File content not found',
  '文件名无效': 'Invalid filename',
  '文件名过长': 'Filename is too long',
  '文件路径无效': 'Invalid file path',
  '文件夹不存在': 'Folder not found',
  'MIME类型无效': 'Invalid MIME type',
  '该文件类型不允许上传到此文件夹': 'This file type cannot be uploaded to this folder',
  '无权访问此文件': 'You do not have access to this file',
  '无权修改此文件': 'You cannot modify this file',
  '无权删除此文件': 'You cannot delete this file',
  '分享链接不存在': 'Share link not found',
  '分享链接已过期': 'Share link expired',
  '需要访问密码': 'Access password required',
  '访问密码错误': 'Incorrect access password',
  '下载次数已达上限': 'Download limit reached',
  '上传次数已达上限': 'Upload limit reached',
  '分享的文件不存在': 'Shared file not found',
  '分享的文件夹不存在': 'Shared folder not found',
  '无效的分享ID': 'Invalid share ID',
  '无效的上传令牌': 'Invalid upload token',
  '无权创建分享': 'You cannot create a share',
  '无权删除此分享': 'You cannot delete this share',
  '此分享不支持上传': 'Uploads are not allowed for this share',
  '此分享不支持下载': 'Downloads are not allowed for this share',
  '分享已存在': 'Share already exists',
  '此链接为上传链接，不可下载': 'This is an upload link; downloads are not allowed',
  '此链接为下载链接，不可上传': 'This is a download link; uploads are not allowed',
  '文件已在回收站': 'File is already in the trash',
  '文件不在回收站中': 'File is not in the trash',
  '文件已恢复': 'File already restored',
  '文件已存在': 'File already exists',
  '文件夹已存在': 'Folder already exists',
  '文件夹不为空': 'Folder is not empty',
  '不能将文件移动到自身': 'Cannot move a file to itself',
  '不能将文件夹移动到其子文件夹中': 'Cannot move a folder into its own subfolder',
  '不能删除根目录': 'Cannot delete the root directory',
  '存储空间不足': 'Insufficient storage space',
  '存储桶不存在': 'Bucket not found',
  '存储桶连接失败': 'Bucket connection failed',
  '存储桶未激活': 'Bucket is inactive',
  '存储桶配额已满': 'Bucket quota reached',
  '未配置存储桶': 'No bucket configured',
  '生成预签名URL失败': 'Failed to generate presigned URL',
  '创建存储桶失败': 'Failed to create bucket',
  '更新存储桶失败': 'Failed to update bucket',
  '删除存储桶失败': 'Failed to delete bucket',
  '存储桶连接测试失败': 'Bucket connection test failed',
  '存储桶迁移失败': 'Bucket migration failed',
  '存储桶名称无效': 'Invalid bucket name',
  '端点URL无效': 'Invalid endpoint URL',
  '访问密钥无效': 'Invalid access key',
  '密钥无效': 'Invalid secret key',
  '不支持的存储提供商': 'Unsupported storage provider',
  '无权访问此存储桶': 'You do not have access to this bucket',
  '需要存储桶所有者权限': 'Bucket owner permission required',
  '存储桶已存在': 'Bucket already exists',
  '存储桶正在使用中，无法删除': 'Bucket is in use and cannot be deleted',
  '已存在默认存储桶': 'A default bucket already exists',
  '用户不存在': 'User not found',
  '创建用户失败': 'Failed to create user',
  '更新用户失败': 'Failed to update user',
  '删除用户失败': 'Failed to delete user',
  '用户ID无效': 'Invalid user ID',
  '无权访问此用户信息': 'You do not have access to this user',
  '不能删除自己的账户': 'Cannot delete your own account',
  '不能修改管理员账户': 'Cannot modify an administrator account',
  '用户已存在': 'User already exists',
  '任务不存在': 'Task not found',
  '任务已过期': 'Task expired',
  '创建任务失败': 'Failed to create task',
  '取消任务失败': 'Failed to cancel task',
  '重试任务失败': 'Failed to retry task',
  'URL格式无效': 'Invalid URL format',
  '不支持的URL类型': 'Unsupported URL type',
  '任务正在运行中': 'Task is already running',
  '任务已完成': 'Task already completed',
  '任务已取消': 'Task already cancelled',
  '任务已失败': 'Task already failed',
  '无法暂停此任务': 'Cannot pause this task',
  '无法恢复此任务': 'Cannot resume this task',
  '只能重试失败的任务': 'Only failed tasks can be retried',
  '无法删除正在运行的任务': 'Cannot delete a running task',
  '权限记录不存在': 'Permission record not found',
  '创建权限失败': 'Failed to create permission',
  '删除权限失败': 'Failed to delete permission',
  '无效的权限级别': 'Invalid permission level',
  '权限已存在': 'Permission already exists',
  '不能修改所有者权限': 'Cannot modify owner permissions',
  '版本不存在': 'Version not found',
  '创建版本失败': 'Failed to create version',
  '恢复版本失败': 'Failed to restore version',
  '删除版本失败': 'Failed to delete version',
  '版本对比失败': 'Version comparison failed',
  '无效的版本号': 'Invalid version number',
  '此文件不支持版本控制': 'Versioning is not supported for this file',
  '文件夹不支持版本控制': 'Versioning is not supported for folders',
  '版本数量已达上限': 'Version limit reached',
  '不能删除当前版本': 'Cannot delete the current version',
  'AI服务暂不可用': 'AI service temporarily unavailable',
  'AI分析失败': 'AI analysis failed',
  'OCR识别失败': 'OCR recognition failed',
  '图像分类失败': 'Image classification failed',
  '此文件类型不支持AI分析': 'AI analysis is not supported for this file type',
  '文件过大，无法进行AI分析': 'File is too large for AI analysis',
  'AI调用次数已达上限': 'AI request limit reached',
  'Telegram上传失败': 'Telegram upload failed',
  'Telegram下载失败': 'Telegram download failed',
  'Telegram删除失败': 'Telegram deletion failed',
  'Telegram文件引用不存在': 'Telegram file reference not found',
  'Telegram配置错误': 'Telegram configuration error',
  '文件超过Telegram限制（最大2GB）': 'File exceeds the Telegram limit (maximum 2 GB)',
  'Telegram分片下载失败': 'Telegram multipart download failed',
  '账户安全状态已变化，请重新登录': 'Account security has changed. Please sign in again',
};
